<template>
  <div class="addNewClass">
    <div class="content">
      <div class="operation">
        <div>
          <template>
            <el-button size="mini" :icon="fold ? 'el-icon-caret-top':'el-icon-caret-bottom'" @click="fold = !fold">折叠所有</el-button>
          </template>
        </div>
        <div>
          <el-button size="mini" @click="openHint(1)">新增一级分组</el-button>
        </div>
      </div>
      <div class="cardBox">
        <div class="cardSub">
          <div class="cardTop">
            <div class="lft" @click="switchOff = !switchOff">∨ 系统分组</div>
            <div class="rgt">
              <el-switch v-model="values" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
            </div>
          </div>
          <el-collapse-transition>
            <div class="cardBtm" v-show="switchOff">
              <div class="line-cell">
                <div>
                  <span style="color:#5090FF">*新品上架</span>&nbsp;
                  <span style="color:#999999">（系统自动读取最新上架的20个商品）</span>
                </div>
                <div>
                  <span>显示</span>
                </div>
              </div>
              <div class="line-cell">
                <div>
                  <span style="color:#5090FF">*热销排行</span>&nbsp;
                  <span style="color:#999999">（系统自动读取最新上架的20个商品）</span>
                </div>
                <div>
                  <span>显示</span>
                </div>
              </div>
              <div class="line-cell">
                <div>
                  <span style="color:#5090FF">*列表中隐藏</span>&nbsp;
                  <span style="color:#999999"></span>
                </div>
                <div>
                  <span style="color:#999999">该分组默认不会展示在买家页面</span>
                </div>
              </div>
              <div class="line-cell">
                <div>
                  <span style="color:#5090FF">*未分组</span>&nbsp;
                  <span style="color:#999999"></span>
                </div>
                <div>
                  <span style="color:#999999">该分组默认不会展示在买家页面</span>
                </div>
              </div>
            </div>
          </el-collapse-transition>
        </div>
      </div>
      <div class="cardBox" v-for="(item, index) in GroundsList" :key="index">
        <div class="cardSub">
          <div class="cardTop">
            <div class="lft cursor" @click="showSecond(index, item.id)">∨ {{ item.name }}</div>
            <div class="rgt rgts cursor">
              <span @click="addTwoLeave(item, index)">新增二级分组</span>
              <span @click="editGroup(item, index)"> 编辑 </span>
              <span @click="delgrops(item.id)"> 删除 </span>
            </div>
          </div>
          <el-collapse-transition>
            <div class="cardBtm" v-show="nowIndex == index ? true : false">
              <div class="line-cell" v-for="(child, idx) in item.child" :key="idx">
                <div class="twoGroup">
                  <div class="twoImg"><img :src="child.img" alt=""></div>
                  <span>{{child.name}}</span>&nbsp;
                </div>
                <div class="cursor">
                  <span style="color:#5090ff;margin-right:28px;" @click="editTwoGrops(child)">编辑</span>
                  <span style="color:#5090ff;" @click="delgrops(child.id)">删除</span>
                </div>
              </div>
            </div>
          </el-collapse-transition>
        </div>
      </div>
    </div>
    <!-- 添加分组 -->
    <div class="shade" v-show="showHint">
      <div class="hintCont">
        <div class="title">
          <span>编辑分组</span>
          <img src="@/assets/images/close.png" alt @click="closePage" />
        </div>
        <div class="hint-content">
          <el-row :gutter="40">
            <el-col :span="8">
              <div class="grid-content bg-purple min-hgt" style="text-align: right;">
                <span>级别</span>
              </div>
            </el-col>
            <el-col :span="16">
              <div class="grid-content bg-purple min-hgt">
                <template>
                  <el-radio v-model="changeClass" label="1">一级</el-radio>
                  <el-radio v-model="changeClass" label="2">二级</el-radio>
                </template>
              </div>
            </el-col>
          </el-row>
          <!-- 切换分级 -->
          <div class="changeOne" v-if="changeClass == 1">
            <el-row :gutter="40">
              <el-col :span="8">
                <div class="grid-content bg-purple min-hgt" style="text-align: right;">
                  <span>一级分组名称</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple min-hgt">
                  <el-input v-model="oneName" size="small">
                    <!-- <span slot="suffix">0/5</span> -->
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="40">
              <el-col :span="8">
                <div class="grid-content bg-purple min-hgt" style="text-align: right;">
                  <span>商品</span>
                </div>
              </el-col>
              <el-col :span="14">
                <div class="grid-content bg-purple min-hgt">
                  <div v-if="sList.length" class="goods_line">
                    <div>已选择</div>
                    <div class="goods_name">{{selectNames}}</div>
                    <div>等<span>{{sList.length}}</span>件商品</div>
                  </div>
                  <el-button @click="showSelecter = true" type="text">选择商品</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="changeTwo" v-else>
            <el-row :gutter="40">
              <el-col :span="8">
                <div class="grid-content bg-purple min-hgt" style="text-align: right;">
                  <span>一级分组名称</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple min-hgt">
                  <template>
                    <el-select v-model="oneNameValue" placeholder="请选择" size="small">
                      <el-option v-for="item in oneOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </template>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="40">
              <el-col :span="8">
                <div class="grid-content bg-purple min-hgt" style="text-align: right;">
                  <span>二级分组名称</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple min-hgt">
                  <el-input v-model="twoName" size="small">
                    <!-- <span slot="suffix">0/5</span> -->
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="40">
              <el-col :span="8">
                <div class="grid-content bg-purple min-hgt" style="text-align: right;">
                  <span>二级分组图片</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple min-hgt">
                  <el-upload
                    class="avatar-uploader"
                    action="https://www.58zltc.com/api/Upload/uploads/"
                    :show-file-list="false"
                    accept="image/*"
                    :data="imgdata"
                    :before-upload="upBefore"
                    :on-success="handleAvatarSuccess">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="40">
              <el-col :span="8">
                <div class="grid-content bg-purple min-hgt" style="text-align: right;">
                  <span>商品</span>
                </div>
              </el-col>
              <el-col :span="14">
                <div class="grid-content bg-purple min-hgt">
                  <div v-if="sList.length" class="goods_line">
                    <div>已选择</div>
                    <div class="goods_name">{{selectNames}}</div>
                    <div>等<span>{{sList.length}}</span>件商品</div>
                  </div>
                  <el-button type="text" @click="showSelecter = true">选择商品</el-button>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="40">
              <el-col :span="8">
                <div class="grid-content bg-purple min-hgt" style="text-align: right;">
                  <span>热门推荐</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple min-hgt">
                  <template>
                    <el-radio v-model="hotRadio" label="0">关闭</el-radio>
                    <el-radio v-model="hotRadio" label="1">开启</el-radio>
                  </template>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="Operation">
            <el-button type="primary" size="small" @click="submit">
              确认
            </el-button>
            <el-button size="small" @click="closePage">取消</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <selectCommodity @close="showSelecter = false" @getCommod="getCommod" :sList="sList"></selectCommodity>
    </el-dialog>
  </div>
</template>

<script>
import selectCommodity from "@/components/commodity/selectCommodity.vue";
import { Addgroup, groupList, groupDel, groupChild, groupEdit} from "@/api/mall";
import { mapGetters } from "vuex";
export default {
  components: {
    selectCommodity
  },
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  data() {
    return {
      editid: "",
      imageUrl: "",
      showAdd: false,
      showHint: false,
      values: true,
      fold: false,
      chooseGoods: false,
      changeClass: "1",
      fileList: [],
      oneNameValue: "",
      newOrEdit: 0,
      idx: 1,
      group: "", // 商品分类
      nowIDx: 0,
      imgdata: {
        token: "",
        image: "",
        type: "1",
        file_group: "1"
      },
      value: "",
      input: "",
      input3: "",
      radio: "",
      switchOff: false,
      nowIndex: -1,
      oneName: "",
      twoName: "",
      page: "1",
      hotRadio: "1",
      GroundsList: [],
      oneOptions: [],
      pic_id: "",
      showSelecter: false, //显示商品选择
      ids: "", //选择的商品id字符串
      sList: [], //已选择的商品列表
      selectNames: "", //已选择的商品名
    };
  },
  mounted() {
    this.imgdata.token = this.token;
    console.log(this.imgdata)
    this.getgroupList();
  },
  methods: {
    editTwoGrops(item) {
      console.log("编辑传入的",item);
      // return;
      this.editid = item.id;
      this.newOrEdit = 1;
      this.changeClass = String(2);
      this.showHint = true;
      this.twoName = item.name;
      this.imageUrl = item.img;
      this.hotRadio = item.is_rec;
      this.oneNameValue = item.pid;
      // 传已选商品
      var ids = "";
      var name = "";
      this.sList = [];
      var goodss = item.goods;
      goodss.forEach( n =>{
        ids += n.id + ',';
        name += n.name + ',';
        this.sList.push({
          id:n.id,
          name:n.name,
          url:n.image[0].url
        });
      });
      ids = ids.substring(0,ids.length-1);
      name = name.substring(0,name.length-1);
      this.ids = ids;
        // console.log("二级分组列表",n);

      console.log("二级分组id",this.ids);
      this.selectNames = name;
    },
    editGroup(item, index) {
      this.editid = item.id;
      console.log(item, index)
      // 编辑一级分组
      this.openHint(1);
      this.oneName = item.name;
      this.newOrEdit = 1;
      // 传已选商品
      var ids = "";
      var name = "";
      this.sList = [];
      item.goods.forEach( n =>{
        ids += n.id + ',';
        name += n.name + ',';
        this.sList.push({
          id:n.id,
          name:n.name,
          url:n.image[0].url
        })
      });
      ids = ids.substring(0,ids.length-1);
      name = name.substring(0,name.length-1);
      this.ids = ids;
      console.log(this.ids);
      this.selectNames = name;
    },
    changeImg() {
      if(this.fileList.length >=1 ) {
        this.fileList.shift();
      }
    },
    // 显示二级分组
    showSecond(index, id) {
      this.nowIndex = this.nowIndex == index? -1:index;
      // groupChild(id).then(res => {
      //   console.log(res)
      // })
    },
    upBefore(file) {
      // 上传之前
      console.log(file)
      this.imgdata.image = file;
      console.log(this.imgdata);
      this.imageUrl = URL.createObjectURL(file);
    },
    handleAvatarSuccess(file) {
      // 图片上传成功
      console.log(file);
      this.pic_id = file.data.id;
    },
    openHint(num) {
      // 新增一级
      this.newOrEdit = 0;
      this.changeClass = String(num);
      console.log(this.changeClass);
      this.showHint = true;
    },
    // 新增二级
    addTwoLeave(item, index) {
      this.newOrEdit = 0;
      this.changeClass = String(2);
      this.showHint = true;
    },
    delgrops(id) {
      // 删除分组
      let data = {
        token: this.token,
        id: id
      };
      groupDel(data).then(res => {
        console.log(res);
        this.getgroupList();
      });
    },
    closePage() {
      this.empty();
      this.showHint = false;
    },
    closeAdd(item) {
      this.showAdd = item;
    },
    select() {
      this.showAdd = true;
    },
    // 获取分组列表
    getgroupList() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id,
        store_id: "0",
        page: this.page
      };
      groupList(data).then(res => {
        console.log("分组列表",res);
        this.GroundsList = res.data;
        // 获取一级分组名称
        let obj = {};
        this.oneOptions = [];
        for (let i = 0; i < this.GroundsList.length; i++) {
          const element = this.GroundsList[i];
          console.log(element);
          obj.value = element.id;
          obj.label = element.name;
          console.log(obj);
          this.oneOptions.push(obj);
          obj = {};
        }
        console.log(this.oneOptions);
        this.empty();
      });
    },
    empty() {
      this.twoName = "";
      this.imageUrl = "";
      this.hotRadio = "";
      this.oneNameValue = "";
      this.oneName = "";
    },
    getCommod(data){
      console.log(data)
      this.sList = data;
      var ids = "",name = ""
      data.forEach(item=>{
        ids += item.id + ","
        name += item.name + ","
      })
      ids = ids.substring(0,ids.length-1);
      name = name.substring(0,name.length-1);
      // if(name.split('').length>5){
      //   name = name.substring(0,5) + "..."
      // }
      this.showSelecter = false;
      this.ids = ids;
      console.log(this.ids);
      this.selectNames = name;
    },
    submit() {
      // 提交添加信息
      let data = {};
      if (this.changeClass == "1" && this.newOrEdit == 0) {
        console.log("一级");
        data = {
          token: this.token,
          merch_id: this.merch_id,
          store_id: "0",
          app_id: this.app_id,
          name: this.oneName,
          level: "1",
          pid: "0",
          goods_ids: this.ids
        };
      } else if (this.changeClass == "2" && this.newOrEdit == 0) {
        data = {
          token: this.token,
          merch_id: this.merch_id,
          store_id: "0",
          app_id: this.app_id,
          name: this.twoName,
          pic: this.pic_id,
          is_rec: this.hotRadio,
          level: "2",
          pid: String(this.oneNameValue),
          goods_ids: this.ids
        };
      }
      if (this.changeClass == "1" && this.newOrEdit == 1) {
        console.log("一级");
        data = {
          token: this.token,
          id: this.editid,
          name: this.oneName,
          store_id: "0",
          level: "1",
          pid: "0",
          goods_ids: this.ids
        };
      } else if (this.changeClass == "2" && this.newOrEdit == 1) {
        data = {
          token: this.token,
          id: this.editid,
          name: this.twoName,
          pic: this.pic_id,
          is_rec: this.hotRadio,
          store_id: "0",
          level: "2",
          pid: String(this.oneNameValue),
          goods_ids: this.ids
        };
      }
      if (this.newOrEdit == 0) {
        Addgroup(data).then(res => {
          console.log(res);
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.showHint = false;
          this.oneName = "";
          this.getgroupList();
          // 清空已选商品
          this.sList = [];
          this.ids = "";
          this.selectNames = "";
        });
      } else {
        groupEdit(data).then(res => {
          console.log(res);
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.showHint = false;
          this.oneName = "";
          this.getgroupList();
          // 清空已选商品
          this.sList = [];
          this.ids = "";
          this.selectNames = "";
        });
      }
      console.log(data);
    }
  },
  watch:{
    showHint(val){
      console.log("showHint 我被触发",val);
      if(!val){
        console.log('clear sList')
        this.sList = [];
        this.selectNames = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.addNewClass {
  height: 100%;
  position: relative;
  .cursor {
    cursor: pointer;
  }
  .content {
    position: absolute;
    top: 0px;
    bottom: 26px;
    left: 22px;
    right: 70px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 30px;
    .cardBox {
      margin-bottom: 15px;
      .cardSub {
        border: 1px solid #ebeef5;
        // height: 48px;
        padding: 0 12px;
        line-height: 48px;
        .cardTop {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          height: 48px;
          border-bottom: 1px solid #ebeef5;
          .lft {
            cursor: pointer;
          } 
          .rgts {
            width: 180px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            color: #5090ff;
          }
        }
        // .cardBtm {
        //   height: 200px;
        // }
      }
    }
    .operation {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 50px;
    }
    .zdy_title {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
    .line-cell {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 48px;
      line-height: 48px;
      padding-left: 20px;
      cursor: pointer;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      .twoGroup {
        display: flex;
        flex-direction: row;
        align-items: center;
        .twoImg {
          width: 38px;
          height: 38px;
          margin-right: 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      // border-top: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
  .shade {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.3);
    .hintCont {
      position: absolute;
      top: 30%;
      width: 600px;
      left: 50%;
      margin-left: -300px;
      background: #fff;
      min-height: 200px;
      .title {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 10px 20px;
      }
      .hint-content {
        margin-top: 20px;
        .float_lft {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }
        .min-hgt {
          line-height: 36px;

          font-size: 15px;
          min-height: 36px;
          .goods_line{
            display: inline-block;
            margin-right: 4px;
            font-size: 14px;
            div{
              display: inline-block;
              vertical-align:top;
            }
            .goods_name{
              color:#409EFF;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              max-width: 120px;
            }
          }
        }
        .changeTwo {
          .el-select {
            width: 280px;
          }
        }
        .el-row {
          margin-bottom: 10px;
        }
      }
      .Operation {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        min-height: 36px;
        margin: 30px 0 0 0;
        padding: 0 15px 20px 0;
      }
    }
  }
  .search-group {
    width: 62%;
  }
  .upIMgs {
    display: flex;
    flex-direction: column;
    img {
      width: 100px;
      height: 100px;
      margin-top: 10px;
    }
  }
}
</style>


<style lang="scss">
.addNewClass {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  .avatar {
    width: 80px;
    height: 80px;
    display: block;
  }
}
</style>